import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class MobileNotificationsApi {
  public static route = process.env.VUE_APP_NOTIFICATIONS_BASE_URI
  public static entity = 'mobile-notifications'

  public static async get(params: string): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/${this.entity}${params}`)
  }

  public static async getTopics(): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/topics`)
  }

  public static async create(data: object): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/${this.entity}`, data)
  }

  public static async update(id: bigint, data: object): Promise<AxiosResponse> {
    return await axios.put(`${this.route}/${this.entity}/${id}`, data)
  }

  public static async send(data: object): Promise<AxiosResponse> {
    return await axios.post(`${this.route}/${this.entity}/send`, data)
  }
}
